<template>
<van-nav-bar
    title="个人信息核对与采集"
    left-text="返回"
    left-arrow
    @click-left="onClickLeft"
  />
      <van-form @submit="submitForm" >
  <van-field
    v-model="ruleForm.oldPassword"
    name="oldPassword"
    label="* 原密码"
   
    placeholder="原密码"
    :rules="[{ required: true, message: '请填写原密码' }]"
  />
   <van-field
    v-model="ruleForm.NewPassword"
    name="NewPassword"
   
    label="* 新密码"
    placeholder="新密码"
    :rules="[{ required: true, message: '请填写新密码' }]"
  />
  <van-field
    v-model="ruleForm.NewPasswordTwo"
    
    name="NewPasswordTwo"
    label="* 确认新密码"
    placeholder="确认新密码"
    :rules="[{ required: true, message: '请确认新密码' }]"
  />
   <div style="margin: 16px">
      <van-row gutter="20">
        <van-col span="12"
          ><van-button block type="primary" class="button-cuc" @click="resetForm()"
            >重置</van-button
          ></van-col
        >
        <van-col span="12"
          ><van-button block type="primary" class="button-cuc" native-type="submit"
            >提交</van-button
          ></van-col
        >
      </van-row>
    </div>
</van-form>

</template>
<style scoped>
.el-div {
  width: 1200px;
  margin: 30px auto;
}
.el-input {
  display: block;
  width: 380px;
}  
.button-cuc{
  color: #fff;
  background: #059490;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  border-color: #dcdfe6;
  text-align: center;
  font-weight: 500;
  padding: 7px 20px;
  font-size: 14px;
  border-radius: 4px;
}
</style>
<script>
import { Toast } from "vant";
import { UpdatePassword } from "../../http/api.ts";
import Route from "../../router/index";
export default {
 
  data() {        
    return {
      ruleForm: {
        oldPassword: "",
        NewPassword: "",
        NewPasswordTwo: "",
      }
          };
  },
  methods: {
    submitForm(formName) {    
          if(this.ruleForm.NewPassword!=this.ruleForm.NewPasswordTwo){
            Toast.fail('新密码与确认新密码输入不一致！');
            return false;
          }  
          UpdatePassword(formName).then((res) => {
            if (res.code == 200) {
              Toast.success(res.msg);
              setTimeout(function () {
                  Route.push("/m/read?tmsite="+Math.random());
              }, 1000);
            }else{
             Toast.fail(res.msg);
            }
          }); 
    },
    resetForm() {
        this.ruleForm.oldPassword='';
        this.ruleForm.NewPassword='';
        this.ruleForm.NewPasswordTwo='';
    },
    onClickLeft() {
      history.go(-1);
    }
  },
};
</script>